import { ASPECT_PRESETS } from '../lib/exportConstants';
import { DISC_SIZE_RATIOS } from '../lib/drawFrame';

const MAX_LONG_SIDE = 640;

// Computes the on-screen preview box size (respecting the export aspect
// ratio and the available width) and the resulting disc diameter in px.
export function usePreviewLayout(exportSettings, disc, availableWidth) {
  const aspect = ASPECT_PRESETS[exportSettings.aspect] || ASPECT_PRESETS.vertical;
  const ratio = aspect.w / aspect.h;
  const isMobile = (availableWidth || MAX_LONG_SIDE) < 640;
  const maxW = Math.min(MAX_LONG_SIDE, availableWidth || MAX_LONG_SIDE);
  // On narrow screens the preview shouldn't dominate the whole first
  // viewport and push every control below the fold -- cap it much shorter
  // than the desktop's "big hero preview" sizing.
  const maxH = Math.min(
    isMobile ? 320 : MAX_LONG_SIDE,
    Math.round(window.innerHeight * (isMobile ? 0.36 : 0.62)),
  );
  let cssW, cssH;
  if (ratio >= 1) {
    cssW = maxW;
    cssH = Math.round(cssW / ratio);
    if (cssH > maxH) { cssH = maxH; cssW = Math.round(cssH * ratio); }
  } else {
    cssH = maxH;
    cssW = Math.round(cssH * ratio);
    if (cssW > maxW) { cssW = maxW; cssH = Math.round(cssW / ratio); }
  }

  const sizeRatio = DISC_SIZE_RATIOS[disc.size] || DISC_SIZE_RATIOS['12in'];
  const discOutputPx = Math.max(8, Math.round(Math.min(cssW, cssH) * sizeRatio * (disc.zoom || 1)));

  // Placeholder icon/text scale with the box itself instead of staying a
  // fixed pixel size, so they look right whether the preview is a small
  // mobile square or a large desktop frame.
  const placeholderIconPx = Math.max(24, Math.min(56, Math.round(Math.min(cssW, cssH) * 0.11)));
  const placeholderFontPx = Math.max(11, Math.min(16, Math.round(Math.min(cssW, cssH) * 0.03)));

  return { cssW, cssH, discOutputPx, placeholderIconPx, placeholderFontPx };
}
